import { valibotResolver } from "@hookform/resolvers/valibot";
import { PencilSimpleLine } from "@phosphor-icons/react";
import { useState } from "react";
import { useForm } from "react-hook-form";

import { Button } from "common/components/ui/Button";
import FormField from "common/components/ui/FormField";
import { Input } from "common/components/ui/Input";
import useCustomer from "common/datahooks/useCustomer";

import { FullNameSchema } from "../../schema";
import SettingsItemContainer from "../SettingsItemContainer";

export default function FullName() {
  const [isEditing, setIsEditing] = useState(false);
  const { customerInfo, updateCustomer, isCustomerUpdating } = useCustomer();
  const {
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<{
    firstName: string;
    lastName: string;
  }>({
    resolver: valibotResolver(FullNameSchema),
    defaultValues: {
      firstName: customerInfo.first_name,
      lastName: customerInfo.last_name,
    },
  });

  async function onSubmit({
    firstName,
    lastName,
  }: {
    firstName: string;
    lastName: string;
  }) {
    if (
      firstName !== customerInfo.first_name ||
      lastName !== customerInfo.last_name
    ) {
      await updateCustomer({ firstName, lastName });
    }
    setIsEditing(false);
  }
  function onCancel() {
    setIsEditing(false);
    reset({
      firstName: customerInfo.first_name,
      lastName: customerInfo.last_name,
    });
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <SettingsItemContainer className="items-center gap-x-2">
        {isEditing ? (
          <>
            <div className="flex w-full gap-x-2">
              <FormField
                label="First name"
                htmlFor="firstName"
                size="sm"
                className="flex-1"
                error={errors.firstName?.message}
              >
                <Input
                  placeholder="First name"
                  id="firstName"
                  variant="sm"
                  {...register("firstName")}
                />
              </FormField>
              <FormField
                label="Last name"
                htmlFor="lastName"
                size="sm"
                className="flex-1"
                error={errors.lastName?.message}
              >
                <Input
                  placeholder="Last name"
                  id="lastName"
                  variant="sm"
                  {...register("lastName")}
                />
              </FormField>
            </div>
            <div className="flex gap-x-2 mt-auto ml-auto">
              <Button
                variant="secondary-black"
                type="button"
                size="sm"
                onClick={onCancel}
                disabled={isCustomerUpdating}
              >
                Cancel
              </Button>
              <Button size="sm" type="submit" isLoading={isCustomerUpdating}>
                Save
              </Button>
            </div>
          </>
        ) : (
          <>
            <div className="flex flex-col gap-y-0.5">
              <span className="text-sm-bold">Full name</span>
              <span className="text-black-500 text-xs-medium">
                {customerInfo.first_name} {customerInfo.last_name}
              </span>
            </div>
            <Button
              variant="ghost-black"
              intent="iconOnly"
              className="ml-auto"
              onClick={() => setIsEditing(true)}
            >
              <PencilSimpleLine />
            </Button>
          </>
        )}
      </SettingsItemContainer>
    </form>
  );
}
